import router from '../router'

// beforeEach
router.beforeEach((to, from, next) => {
  if(to.meta.title) {
    document.title = to.meta.title
  }

  next();
})


// WEBPACK FOOTER //
// ./src/assets/permission.js